import Base from 'app/views/base';
import UserEditInfoView from 'app/components/pages/user_edit/edit_info';
import UserEditPasswordView from 'app/components/pages/user_edit/edit_password';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'user-info',

  initialize() {
    this.addSubview('userInfo', '#user_info', new UserEditInfoView({ model: this.model }));
    this.addSubview('userPassword', '#user_password', new UserEditPasswordView({ model: this.model }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/user_edit/index.js